module.exports = __webpack_public_path__ + "6b2ffde980c3d5f6a650193fc998be66.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MO.svg
// module id = Mx4f
// module chunks = 0